/*
 * Product page extras that follow the chosen variant: the "pay in instalments" message and the back-in-stock request.
 * The pure functions at the top are exported for the unit tests in tests/unit.
 */
(() => {
  /** One instalment in cents, rounded up so the instalments never add up to less than the price. */
  const instalment = (priceCents, count) => (Number(count) > 0 && Number(priceCents) > 0 ? Math.ceil(Number(priceCents) / Number(count)) : 0);

  /** The message is only for prices at or above the store's minimum. */
  const showPlan = (priceCents, minimumCents) => Number(priceCents) > 0 && Number(priceCents) >= Number(minimumCents || 0);

  /** The text sent to the store with a back-in-stock request, so the owner knows which product and size it is for. */
  const requestText = (title, variantTitle, sku) => {
    const variant = variantTitle && variantTitle !== 'Default Title' ? ` - ${variantTitle}` : '';
    return `Back in stock request: ${title}${variant}${sku ? ` (SKU ${sku})` : ''}`;
  };

  const formatMoney = (cents, currency = 'AUD') => {
    try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency }).format(cents / 100); } catch (error) { return `$${(cents / 100).toFixed(2)}`; }
  };

  const api = { instalment, showPlan, requestText, formatMoney };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window === 'undefined') return;
  window.ShopStarProductExtras = api;

  const init = () => {
    document.querySelectorAll('[data-product-form-scope]').forEach((scope) => {
      const plan = scope.querySelector('[data-payment-plan]');
      const amount = scope.querySelector('[data-payment-plan-amount]');
      const request = scope.querySelector('[data-back-in-stock]');
      const body = request?.querySelector('[data-back-in-stock-body]');
      const productTitle = scope.dataset.productTitle || document.title;
      scope.addEventListener('shopstar:variant_change', (event) => {
        const variant = event.detail?.variant;
        if (!variant) return;
        const currency = window.Shopify?.currency?.active || 'AUD';
        if (plan && amount) {
          plan.hidden = !showPlan(variant.price, Number(plan.dataset.minCents));
          amount.textContent = formatMoney(instalment(variant.price, Number(plan.dataset.count)), currency);
        }
        if (request && !request.dataset.posted) request.hidden = Boolean(variant.available);
        if (body) body.value = requestText(productTitle, variant.title, variant.sku);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
